import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {GoogleAnalyticsService} from '../../services/google-analytics/google-analytics.service';
import {Session} from '../../interfaces/session-data';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit {

  oneClickEnabled = false;
  session: Session;
  paymentTypes = [];

  constructor(
    public sanitizer: DomSanitizer,
    private googleAnalyticsService: GoogleAnalyticsService
    ) {}

  ngOnInit(): void {
    this.session = JSON.parse(sessionStorage.getItem('sessionData'));
    for (const elt of this.session.virtualConfiguration.paymentTypes) {
      this.paymentTypes.push(elt.code);
    }
    this.googleAnalyticsService
      .pageViewEvent('virtual.initialise.portal.component', 'initialise.payment.selection');
    this.googleAnalyticsService
      .pushDataLayerVariable('session.token', sessionStorage.getItem('sessionToken'));
    this.googleAnalyticsService
      .pushDataLayerVariable('session.payment.types', this.paymentTypes.toString());
  }

}
